"use strict";
import {createSwiper} from "./swiper";
import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from '@elements/dom-utils';

export function init () {

    onFind('.js-portal-slider', function (sliderElement) {
        createSwiper(sliderElement, {
                loop: true,
                slidesPerView: 1,
                navigation: {
                    findNextElement: swiperContainer => findIn('.js-portal-slider__next', swiperContainer),
                    findPrevElement: swiperContainer => findIn('.js-portal-slider__prev', swiperContainer),
                },
                pagination: {
                    el: swiperContainer => findIn('.js-portal-slider__pagination', swiperContainer),
                    clickable: true
                }
            },
            {
                sliderContainer: '.js-portal-slider',
                slider: '.js-portal-slider__slider'
            });

    });
}

